import ComponentHelper from '../../../supers/ComponentHelper';
import Modal from 'react-modal';
import React from 'react';
import '../install-app-modal/install-app-modal.css';
import Spinner from '../../../components/spinner/Spinner';
import RESTService from '../../../services/RESTService';
import Dropdown from '../../../components/dropdown/Dropdown';
import CommonService from '../../../services/CommonService';
import InputField from '../../../components/input-field/InputField';
import ValidationService from '../../../services/ValidationService';
import _ from 'lodash';
import RoutingService from '../../../services/RoutingService';
const connect = new RESTService();
const CS = new CommonService();
const VS = new ValidationService();
const RS = new RoutingService();

class CreateEnvironmentModal extends ComponentHelper {
	constructor(props) {
		super(props);
		this.setInitialData();
	}

	setInitialData = () => {
		this.data = {
			title: 'New Environment',
			saving: false,
			errorMessage: null,
			applications: [],
			selectedApp: '',
			selectedVersion: '',
			appMap: {},
			warning: null,
			environment: '',
			description: ''
		};
	};

	onValueChange = evt => {
		const { name, value } = evt.target;
		if (name === 'environment' && !VS.validateName(value)) {
			return;
		}
		this.observe(() => {
			this.data[name] = value;
		});
	};

	// Clear component state when modal is re-open
	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
			connect.getInstallableApps().then(res => {
				this.observe(() => {
					let apps = [];
					_.forEach(res.data, app => {
						if (app.published) {
							apps.push(app);
						}
					});
					this.data.applications = apps;
					this.data.appMap = CS.mapByParam('_id', apps);
				});
			});
		}
	}

	isValidInput() {
		if (this.data.environment.length <= 0) {
			return false;
		}
		return true;
	}

	clearError = () => {
		this.setData('errorMessage', null);
	};

	onInstall = () => {
		this.setData('saving', true);
		let selected = this.data.appMap[this.data.selectedApp];
		connect
			.createEnvironment({
				name: this.data.environment,
				description: this.data.description
			})
			.then(res => {
				this.environment = res.data;
				RS.setCurrentEnvironment(res.data.name);
				if (selected) {
					let selected = this.data.appMap[this.data.selectedApp];
					let apps = this.environment.installedApps;
					if (!apps) {
						apps = {};
					}
					if (apps && selected) {
						let toInstall = {
							_id: selected._id,
							name: selected.name,
							installDate: new Date(),
							version: selected.version
						};
						apps[selected.name] = toInstall;
						connect
							.installAppDef(toInstall)
							.then(() => {
								this.environment.installedApps = apps;
								connect
									.updateEnvironment(this.environment)
									.then(() => {
										this.props.onComplete();
									})
									.catch(err => {
										console.error(err);
										this.props.onComplete();
									});
							})
							.catch(err => {
								console.error(err);
								this.props.onComplete();
							});
					} else {
						this.props.onComplete();
					}
				}
			})
			.catch(err => {
				this.observe(() => {
					console.error(err);
					this.data.saving = false;
					this.data.errorMessage = err.response.data;
				});
			});
	};

	getApps = () => {
		let options = [];
		this.data.applications.forEach(app => {
			options.push({
				label: `${app.displayName} - v${app.version}`,
				value: app._id
			});
		});
		return options;
	};

	onAppChange = evt => {
		let app = this.data.appMap[evt.value];
		if (app) {
			this.setData('selectedApp', app._id);
		}
		let installed = this.data.environment.installedApps;
		if (installed && installed[app.name]) {
			this.setData('warning', 'Another version of this app is already installed and will be overwritten.');
		} else {
			this.setData('warning', null);
		}
	};

	render() {
		let { isOpen } = this.props;
		let { title, saving, errorMessage, selectedApp, warning, environment, description } = this.data;
		return (
			<Modal
				contentLabel="Modal"
				ariaHideApp={false}
				isOpen={isOpen}
				className="install-app-modal animated zoomIn"
				overlayClassName="dialog-modal-overlay vbox hcenter vcenter"
			>
				<div className="modal-header">{title}</div>
				{saving ? (
					<Spinner text="Saving..." height="267px" />
				) : errorMessage === null ? (
					<div className="modal-body">
						<InputField
							label="Environment Name"
							subText="Use only lowercase characters, numbers or hyphens."
							type="text"
							name="environment"
							value={environment}
							handleChange={this.onValueChange}
							required
							autoFocus
						/>
						<InputField
							label="Description (optional)"
							subText="The purpose of this new environment."
							type="text"
							name="description"
							value={description}
							handleChange={this.onValueChange}
						/>
						<Dropdown
							className="app-picker"
							label="Initialize this environment with an application?"
							value={selectedApp}
							placeholder="Select an app to install"
							handleChange={this.onAppChange}
							name="authType"
							options={this.getApps()}
						/>
						{warning && (
							<div className="warning-msg hbox vcenter">
								<i className="mdi mdi-alert" /> {warning}
							</div>
						)}
					</div>
				) : (
					<div className="error-message-body vbox vcenter hcenter">{errorMessage}</div>
				)}
				<div className="btn-ctn">
					<button className="btn cancel-btn" onClick={this.props.onClose} disabled={saving}>
						Cancel
					</button>
					<button className="btn primary" onClick={errorMessage ? this.clearError : this.onInstall} disabled={!this.isValidInput() || saving}>
						{errorMessage ? 'Ok' : 'Save'}
					</button>
				</div>
			</Modal>
		);
	}
}
export default CreateEnvironmentModal;



// WEBPACK FOOTER //
// ./src/views/environments-panel/create-environment-modal/CreateEnvironmentModal.js